<div class="landing-container">

  @if (showOffersNotification) {
    <app-notification (dismissNotification)="dismissNotification()">
      <div class="notification-hover">
          <b>Pending Offer</b>&nbsp;
          <p>You have a pending offer.</p>
          <a routerLink="profile">View Offer on your Profile.</a>
      </div>
    </app-notification>
  }


  @if (isShepherd) {
    <div class="body-top">
      <div class="content-left">
        @if (showRolloverNotification) {
          <div class="rollover-holder">
            <div class="rollover-container">
              @if (currentApplicationWindow?.academicYear) {
                <app-notification (dismissNotification)="dismissNotification()" (followRoute)="followRoute()">
                  <div class="notification-hover">
                    <b>Want to be an RS next year?</b>&nbsp;
                    Resubmit your current application now to apply for the
                    &nbsp;{{formattedYear(currentApplicationWindow.academicYear.acyrCode, 1)}}-{{formattedYear(currentApplicationWindow.academicYear.acyrCode, 2)}}&nbsp;year.
                  </div>
                </app-notification>
              }
              
            </div>
            <br>  
          </div>
        }
        
        <h1 class="like-h1 welcome-message">{{welcomeMessage}}</h1>
        <div class="welcome-buttons">
          @if (isRS) {
            <button class="large" [routerLink]="['/dashboard/rs']">Review Applicants</button>
          }
          @if (isFutureRS || isRS) {
            <button class="large" [routerLink]="['/dashboard/cgl-search']">Review Hirable CGLs</button>
          }
          <button class="button large ghost" [routerLink]="['/profile']">View Your Profile</button>
        </div>
      </div>
      <div class="body-top-image">
        <img [src]="welcomeImg" alt="">
      </div>
    </div>
  }

  @if (!isShepherd) {
    <div class="body-top-ns">
      <div class="body-top-ns-image">
        <img [src]="welcomeImg" alt="">
      </div>
      <p class="like-h1 center-text">{{welcomeMessageNS}}</p>
    </div>
  }
  <hr>
    <div class="body-bottom">
      <h2  class="like-h3 position-header">
        {{cards?.length ? 'Open Positions' : 'No Open Positions'}}
      </h2>

      <div class="grid">

        @for (card of cards; track card) {
          @if ($any(card).applicationId) {
            @switch (card.applicationType) {
              @case ('CGL') {
                <ng-container *ngTemplateOutlet="CardRef; context: {imgType: cglImg, headerText: 'Community Group Leader', applicationType: 'CGL', applied: true}"></ng-container>
              }
              @case ('RS') {
                <ng-container *ngTemplateOutlet="CardRef; context: {imgType: rsImg, headerText: 'Resident Shepherd', applicationType: 'RS', applied: true}"></ng-container>
              }
              @case ('CS') {
                <ng-container *ngTemplateOutlet="CardRef; context: {imgType: csImg, headerText: 'Commuter Shepherd', applicationType: 'CS', applied: true}"></ng-container>
              }
              @case ('AS') {
                <ng-container *ngTemplateOutlet="CardRef; context: {imgType: asImg, headerText: 'Athletic Shepherd', applicationType: 'AS', applied: true}"></ng-container>
              }
            }
          }
          @if (!$any(card).applicationId) {
            @switch (card.applicationType) {
              @case ('CGL') {
                <ng-container *ngTemplateOutlet="CardRef; context: {imgType: cglImg, headerText: 'Community Group Leader', applicationType: 'CGL'}"></ng-container>
              }
              @case ('RS') {
                <ng-container *ngTemplateOutlet="CardRef; context: {imgType: rsImg, headerText: 'Resident Shepherd', applicationType: 'RS'}"></ng-container>
              }
              @case ('CS') {
                <ng-container *ngTemplateOutlet="CardRef; context: {imgType: csImg, headerText: 'Commuter Shepherd', applicationType: 'CS'}"></ng-container>
              }
              @case ('AS') {
                <ng-container *ngTemplateOutlet="CardRef; context: {imgType: asImg, headerText: 'Athletic Shepherd', applicationType: 'AS'}"></ng-container>
              }
            }
          }
        }

      </div>
    </div>
  </div>

  <ng-template #CardRef let-imgType="imgType" let-headerText="headerText" let-applicationType="applicationType" let-applied="applied">
    <div [id]="applicationType + '-card' + (applied ? '-applied' : '')" class="card">
      <div class="card-image">
        <img [src]="imgType" alt="">
      </div>
      <div class="text">
        <h3 class="like-h2 card-header">{{headerText}}</h3>
        <p class="body">{{welcomeMessageNS}}</p>
      </div>
      @if (!applied) {
        <button class="button padded" (click)="onApplyClicked(applicationType)" [attr.aria-label]="applyNowAriaLabel(headerText)" >Apply Now</button>
      }
      @if (applied) {
        <app-status-display [showCheck]="true" [badgeOnly]="true">Application Submitted</app-status-display>
      }
    </div>
  </ng-template>

